export default "__VITE_ASSET__DD44Ay21__"